"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputBlock = exports.MainContent = exports.Hero = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Hero = styled_components_1.default.div `
	position: relative;
	height: 240px;
	background: url('/media/images/hero-companies-list.jpg');
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	margin: 0 -1rem;
	padding-top: 80px;

	&:after {
		content: '';
		display: block;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		position: absolute;
		z-index: 0;
		pointer-events: none;
		opacity: 0.9;
		background: url('/media/images/background-gradient.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		transform: rotate(180deg);
	}

	& > * {
		z-index: 1;
		color: white;
	}
`;
exports.MainContent = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	background: ${({ theme }) => theme.color.gray2};
	margin: 0 -1rem;
`;
exports.InputBlock = styled_components_1.default.div `
	width: 300px;
`;
